module.exports = __webpack_public_path__ + "img/translation_explainer3.addbb63d.png";